/* eslint-disable no-console */
import React, { useEffect } from 'react';
import styles from './Features.module.scss';
import FeatureCarousel from './FeatureCarousel';

const HostTab = () => {
  useEffect(() => {
    try {
      const vid = document.getElementById('event-creation');
      vid.play().catch((err) => {
        console.log('ERROR STARTING VIDEO', err);
      });
    } catch (err) {
      console.log(err);
    }
  });

  return (
    <div>
      <div className={styles.FeaturesTab}>
        <div className={styles.Container}>
          <h2>The ultimate events toolkit.</h2>
          <p>
            Easily host events on the Bounce Platform, as well as integrate your
            Facebook event.
          </p>
          <div className={styles.SectionHeadline}>
            <div className={styles.FeatureVid}>
              <video id="event-creation" muted loop playsInline>
                <source src="/vid/event-creation.mp4" type="video/mp4" />
              </video>
            </div>
            <div className={styles.Description}>
              <h2>Make event planning fun</h2>
              <p>
                Easily host events on the Bounce Platform, as well as integrate
                your Facebook event.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: 'white',
          width: '100%',
          padding: '20px 0'
        }}
      >
        <div className={styles.Container}>
          <div className={styles.SectionHeadlineReverse}>
            <div className={styles.Description}>
              <h2>On-Screen Agendas</h2>
              <p>
                Keep your event running on schedule and your event attendees in
                the loop throughout your event.
              </p>
            </div>
            <div style={{ position: 'relative' }}>
              <img
                src="/img/illustrations/landing/agenda-input.png"
                alt="Agenda Input"
              />
              <div>
                <img
                  className={styles.AgendaPopup}
                  src="/img/illustrations/landing/agenda-popup.png"
                  alt="Agenda Popup"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FeatureCarousel />
    </div>
  );
};

export default HostTab;
